import { BrandMode, type AppConfigurationResponse } from "../state/api.types";

/**
 * A plan's display label, e.g. "Acme Home Saver Plan". The partner's brand name
 * is dropped in subtle brand mode.
 */
export function brandedPlanName(
  configuration: AppConfigurationResponse,
  planName: string,
): string {
  if (configuration.brand_mode === BrandMode.Subtle) {
    return `${planName} Plan`;
  }
  return `${configuration.company_name} ${planName} Plan`;
}
